// Arrays
export const URLS_TO_BE_SET_AS_BLOBS = ["receipt", "export", "download", "bulk/template"];
